webpackJsonp([2],{

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__(289);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c36ace_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var normalizeComponent = __webpack_require__(89)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47c36ace"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c36ace_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      names: '',
      email: '',
      telephone: '',
      password: '',
      emailRules: [function (v) {
        return !!v || 'E-mail est requis';
      }, function (v) {
        return (/.+@.+/.test(v) || "L'email doit être valide"
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Mot de passe est requis';
      }],
      nameRules: [function (v) {
        return !!v || 'Ces noms sont requis';
      }, function (v) {
        return (/^[a-zA-Z' a-zA-Z']{2,16}$/.test(v) || 'Les Noms doivent être valides'
        );
      }],
      phoneRules: [function (v) {
        return !!v || 'Votre tel est requis';
      }, function (v) {
        return (/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/.test(v) || 'Le numero doit être valide'
        );
      }]
    };
  },

  methods: {
    signUp: function signUp() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('SIGNUP_USER', {
          names: this.names,
          email: this.email,
          telephone: this.telephone,
          password: this.password,
          photoUrl: null,
          role: 'acheteur'
        });
      }
    },
    signUpWithFacebook: function signUpWithFacebook() {
      this.$store.dispatch('SIGNUP_FACEBOOK');
    }
  }
});

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(307);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(273)("628aa0be", content, true, {});

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(90)(true);
// imports
exports.i(__webpack_require__(274), "");

// module
exports.push([module.i, ".paragraphText[data-v-47c36ace]{font-size:16px}.productNameTextSize[data-v-47c36ace]{font-size:18px}", "", {"version":3,"sources":["/home/winner/Documents/PROJECTS/LIGABLOFOOD/WEB/ligabloFood/src/components/auth/SignUp.vue"],"names":[],"mappings":"AACA,gCACI,cAAgB,CACnB,AACD,sCACI,cAAgB,CACnB","file":"SignUp.vue","sourcesContent":["\n.paragraphText[data-v-47c36ace]{\n    font-size: 16px;\n}\n.productNameTextSize[data-v-47c36ace]{\n    font-size: 18px;\n}\n@import \"../../../node_modules/font-awesome/css/font-awesome.css\";\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md5":""}},[_c('v-card',{staticClass:"pl-5 pt-3 pb-2 pr-5 elevation-10",staticStyle:{"border-radius":"10px"}},[_c('v-card-media',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/logo%2FlogoLigabloFood.png?alt=media&token=7f73a57c-db33-472a-9a1f-dccfc96ebb69","height":"90px","contain":""}}),_vm._v(" "),_c('v-form',{ref:"form",staticClass:"ma-0",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"solo":"","label":"Votre prenom et nom","rules":_vm.nameRules,"type":"text","color":"primary"},model:{value:(_vm.names),callback:function ($$v) {_vm.names=$$v},expression:"names"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","label":"Adresse E-mail","type":"email","required":"","rules":_vm.emailRules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","label":"Numéro de téléphone","type":"tel","rules":_vm.phoneRules,"color":"primary"},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","label":"Mot de passe","type":"password","rules":_vm.passwordRules,"color":"primary"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"block":"","dark":""},on:{"click":_vm.signUp}},[_c('b',[_vm._v("Inscrir")])])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("OU")])]),_vm._v(" "),_c('v-form',[_c('v-btn',{staticClass:"blue darken-4",attrs:{"block":"","dark":""},on:{"click":_vm.signUpWithFacebook}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("fa-facebook")]),_c('b',[_vm._v("Connecter avec Facebook")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.132de34e9f16f42a33d6.js